import { motion } from "framer-motion";
import { ChevronLeft } from "lucide-react";
import { toGenitive } from "@/lib/name-utils";

interface Props {
  value: string;
  name: string;
  onChange: (val: string) => void;
  onNext: () => void;
  onBack: () => void;
}

const SituationInput = ({ value, name, onChange, onNext, onBack }: Props) => {
  const genName = toGenitive(name);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 py-12 relative">
      <button
        onClick={onBack}
        className="fixed top-4 left-4 z-50 w-9 h-9 rounded-full flex items-center justify-center text-foreground bg-card/70 backdrop-blur-sm hover:bg-card transition-colors"
        aria-label="Назад"
      >
        <ChevronLeft size={20} />
      </button>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-lg space-y-6"
      >
        <h2 className="text-2xl md:text-3xl font-serif text-foreground text-center w-full">
          Расскажите немного подробнее
        </h2>

        <p className="text-muted-foreground text-center font-sans">
          Что сейчас происходит у {genName}?
        </p>

        <div
          className="rounded-3xl border bg-card p-6 focus-within:ring-2 focus-within:ring-ring/20 transition-shadow"
          style={{ borderColor: "#E6E2DB" }}
        >
          <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Например: боится темноты и не хочет засыпать один…"
            rows={4}
            className="w-full bg-transparent text-foreground font-sans text-base leading-relaxed resize-none focus:outline-none placeholder:text-muted-foreground/50"
          />
        </div>

        <p className="text-xs text-muted-foreground/60 text-center font-sans">
          Не нужно писать много — достаточно пары предложений
        </p>

        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.97 }}
          onClick={onNext}
          disabled={!value.trim()}
          className="w-full py-4 rounded-[28px] bg-primary text-primary-foreground font-sans font-semibold text-lg transition-opacity disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Далее
        </motion.button>
      </motion.div>
    </div>
  );
};

export default SituationInput;
